<template>
    <div class="meetinglist">

        <div class="title">
            <div class="left">
                {{ name }}
            </div>
            <div class="more" @click="showMeeting">
                查看更多 >
            </div>
        </div>

        <div class="tab_box">
            <div class="tab_item hvr-wobble-bottom" v-for="(item, index) in tabList" :key="index" :class="TabCur == index ? 'activeTab' : '' " @click="TabClick(item, index)" >
                {{ item.name }}
            </div>
        </div>

        <div class="news_list" v-if="InfoList && InfoList.length">
            <div class="news_item " v-for="(item, index) in InfoList" :key="index" @click="showMeetingDetail( item )"  @mouseover="hoverIndex = index" @mouseout="hoverIndex = null" >
                <div class="img_content_box">
                    <div  :class="hoverIndex == index ? 'hvr-grow' :''  ">
                        <img :src="item.meetingImg" v-if="item.meetingImg && item.meetingImg.indexOf('http') != -1" alt="">
                        <img :src="$ImgUrl + item.meetingImg" v-if="item.meetingImg && item.meetingImg.indexOf('http') == -1" alt="">
                        <img src="../../assets/static/index/default.png" v-if="!item.meetingImg" alt="">
                    </div>
                </div>
                <div class="news_title" :class="hoverIndex == index ? 'activeItem' :''  ">
                    {{ item.meetingName }}
                </div>
                <div class="dept">
                         {{ item.deptName }}
                    </div>
                    <div class="time desc">
                        <span class="iconfont icon-shijian"></span>时间: {{ item.startTime }}
                    </div>
                    <div class="address desc">
                        <span class="el-icon-location-outline"></span>地点: {{ item.meetingAddress }}
                    </div>
                    <div class="prople desc">
                        <span class="el-icon-user"></span>参会人数: {{ item.memberCount }}
                    </div>
                    <div class="status-line">
                        <div class="status_left">
                            <span class="iconfont icon-yijieshu"></span> 
                            <span>{{ item.meetingStatusName}}</span>
                        </div>
                        <div class="show_info">
                            <span>查看详情 ></span>
                        </div>
                    </div>
            </div>
        </div>

        <div class="noMore" v-else>
            <img src="../../assets/static/index/nomore.png" alt="">
        </div>

    </div>
</template>

<script>
    export default {
        props: {
            name: String,
            id: Number,
            index: Number
        },
        
        data() {
            return {
                list1: [
                    { name: "全部", id: 0 },{ name: "支部委员会", id: 1 },{ name: "支部委员大会", id: 2 },{ name: "党小组会", id:3 },{ name: "党课",id:4 },
                ],
                list2: [
                    { name: "主题党日", id: 1 },{ name: "谈心谈话", id: 5 },{ name: "投票活动", id:3 },{ name: "志愿活动",id:4 },{ name: "其他",id:6 },
                ],
                TabCur: 0, 
                deptId: 0,
                threeMeetingType: 0,
                InfoList: [],
                buildingPartyType: 2,
                meetingType:1,
                hoverIndex: null,
            }
        },
        created () {
            
        },
        computed: {
            tabList () {
                if ( this.id == 1 ) {
                    // 三会一课
                    return this.list1
                } else {
                    return this.list2
                }
            },
            reqUrl () {
                if ( this.id == 1 ) {
                    return "/lencon/pc/activity/three_meeting_list"
                } else if ( this.id == 2 ) {
                    if ( this.meetingType == 1 || this.meetingType ==5 || this.meetingType == 6  ) {  // 会议类请求接口
                        return "/lencon/pc/activity/meeting_list"
                    } else if ( this.meetingType == 3 ) {  // 投票
                        return "/lencon/pc/activity/voteListWithoutToken"
                    } else if ( this.meetingType == 4 ) { // 志愿活动
                        return "/lencon/pc/activity/volunteerList2"
                    }
                    
                }
            }
        },
        mounted () {
            this.getList();
        },
        methods: {
            // 点击tab
            TabClick ( item, index ) {
                this.TabCur = index
                
                if ( this.id == 1 ) {
                    this.threeMeetingType = item.id 
                } else if ( this.id == 2) {
                    this.meetingType = item.id 
                }
                this.getList()
            },
            // 会议展示
            showMeeting () {
                this.$router.push({
                    path:"/MeetingShow",
                    query: {
                        activeMain: this.index
                    }
                })
            },
            // 会议详情
            showMeetingDetail ( item ) {
                let { meetingType } = this 
                if ( meetingType == 1 || meetingType == 5 || meetingType == 6 ) {
                    this.$router.push(`/MeetingDetail/${ item.meetingId }`)
                } else if ( meetingType == 4 ) {
                    this.$router.push(`/activityDetail/${ item.meetingId }`)
                }
                
            },
            // 获取列表
            async getList () {
                let pageSize = 4 
                let { deptId } = this 
                let data = {}
                if ( this.id == 1 ) {
                    data = {
                        deptId,
                        pageSize,
                        threeMeetingType: this.threeMeetingType
                    }
                } else if ( this.id == 2 ) {
                    if ( this.meetingType == 1 || this.meetingType == 5 || this.meetingType == 6  ) {  // 会议
                        data = {
                            buildingPartyType: this.meetingType == 1 ? '1' : '2',
                            meetingType: `${ this.meetingType }`,
                            deptId,
                            pageSize
                        }
                    } else if ( this.meetingType == 3 ) { // 投票
                        data = {
                            deptId,
                            pageSize,
                        }
                    } else if ( this.meetingType == 4 ) { // 志愿
                        data = {
                            deptId,
                            pageSize
                        }
                    }
                }
                
                let res = await this.$axios.post( this.reqUrl, data )
                console.log( res )
                if ( res.data.code == 1 ) {
                    this.InfoList = res.data.data
                } else {
                    this.InfoList = []
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
@import "../../assets/css/main.scss";
.activeItem {
    color: #2767c4 ;
}
.meetinglist {
    width: 1200px;
    margin:20px auto;
    padding: 30px;
    box-sizing: border-box;
    background-color: #fff;
    height: 600px;
    overflow: hidden;
    .title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-bottom: 10px;
        border-bottom: 1px solid #2767c4 ;
        .left {
            font-size: 24px;
            font-weight: bold;
            color: #2767c4 ;
        }
        .more {
            font-size: 14px;
            color: #b3b3b3;
            cursor: pointer;
        }
    }
    .tab_box {
        width: 100%;
        margin: 30px 0;
        display: flex;
        align-items: center;
        .tab_item {
            font-size: 18px;
            cursor: pointer;
            margin: 0 20px;
            font-weight: bold;
        }
        .activeTab {
            color: #2767c4 ;
        }
    }

    .news_list {
        width: 100%;
        display: flex;
        // justify-content: space-between;
        .news_item {
            width: 265px;
            height: 100%;
            padding-bottom: 10px;
            cursor: pointer;
            margin-right: 22px;
            border: 1px solid #eeeeee;
            border-bottom: none;
            .img_content_box {
                width: 265px;
                height: 188px;
                overflow: hidden;
                img {
                    width: 265px;
                    height: 188px;
                }
            }
            .news_title {
                    font-size: 18px;
                    font-weight: bold;
                    margin-top: 10px;
                    height: 50px;
                    @include MultipleRows(2);
                    padding: 0 10px;
                }
                .dept {
                    font-size: 16px;
                    color: #828181;
                    line-height: 40px;
                    padding:  0 10px;
                }
                .desc {
                    font-size: 14px;
                    color: #8e8e8e;
                    line-height: 30px;
                    padding:  0 10px;
                    span {
                        margin-right: 10px;
                    }
                }
                .status-line {
                    padding:  0 10px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    // padding-right: 50px;
                    padding: 10px ;
                    font-size: 14px;
                    border-top: 1px solid #eeeeee;
                    border-bottom: 1px solid #eeeeee;
                    .status_left {
                        color: #2767c4 ;
                    }
                    .show_info {
                        color: #8e8e8e;
                    }
                }
        }
        
    }
}
</style>